export default "__VITE_ASSET__DhOoMdfH__"